import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  resetSituationsConfigsApiService,
  type ResetSituationsConfigsRequest,
} from "@/generated/fastapi";

export async function resetSituationsConfigs(
  accessToken: string | null | undefined,
  request: ResetSituationsConfigsRequest,
) {
  const response = await resetSituationsConfigsApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(
      `Failed to reset situation configurations (${response.status})`,
    );
  }

  return response.data;
}
